import './wagetype.less';
import * as _ from 'lodash';
import * as utility from '../misc/utility';
import { VariablePrice, wageModelInfos } from '../objects/WageType';

angular.module("tromanWeb").controller('WageTypeEditController', ['tromanServer', 'tromanGlobals', 'DialogControllerBase', '$scope', 'wageType', function (tromanServer, tromanGlobals, DialogControllerBase, $scope, wageType) {

    DialogControllerBase.call(this, tromanServer.WageTypes, $scope);

    const EmptyPeriod = {
        WageModel: 0,
        UseMeetingAccountSettings: false,
        Account: '',
        UnitPeriod: 60,
        SubPeriod: 60,
        UnitPrice: null,
        VariablePrice: new VariablePrice()
    };

    const NoFields = { Times: false, UnitPrice: false, VariablePrice: false };
    function getEnabled(wmid) {
        var wm = wageModelInfos[wmid];
        if (wm) {
            return ({
                Times: wm.hasTimes,
                UnitPrice: wm.hasUnitPrice,
                VariablePrice: wmid === 1
            });
        }
        return NoFields;
    }

    this.isPolitikerEnabled = tromanGlobals.systemInfo.IsPolitikerEnabled;

    this.getTitle = function () { return 'lönearten "' + this.wageType.display + '"'; };
    this.getItem = function () { return this.wageType; };

    this.wageModelChanged = function wageModelChanged() {
        this.period.WageModel = this.selectedWageModel.id;
        if (!this.wageType.Id) {
            this.wageType.WageModelGroup = this.selectedWageModel.group;
        }
        this.enable = getEnabled(this.period.WageModel);
    };

    this.periodChanged = function periodChanged() {
        if (this.period == null) {
            // This should only happen temporarily when a period is removed
            this.selectedWageModel = null;
            this.enable = NoFields;
        } else {
            this.selectedWageModel = _.find(this.activeWageModels, x => x.id === this.period.WageModel);
            this.wageModelChanged();
        }
    };

    function createPeriod(tpl) {
        let np = {
            Id: null,
            From: utility.todayDate(),
            WageModel: tpl.WageModel,
            UseMeetingAccountSettings: tpl.UseMeetingAccountSettings,
            Account: tpl.UseMeetingAccountSettings ? '' : tpl.Account,
            UnitPeriod: tpl.UnitPeriod,
            SubPeriod: tpl.SubPeriod,
            UnitPrice: tpl.UnitPrice,
            VariablePrice: tpl.VariablePrice.clone()
        };

        return np;
    }

    this.canAddPeriod = function canAddPeriod() {
        return this.wageType && this.wageType.Periods[0].Id;
    };

    this.addPeriod = function addPeriod() {
        if (!this.canAddPeriod()) return;

        const np = createPeriod(this.period);
        this.wageType.Periods.unshift(np);
        this.period = np;
        this.periodChanged();

        if (this.editForm) {
            this.editForm.$setDirty();
        }
    };

    this.canRemovePeriod = function canRemovePeriod() {
        return this.wageType && this.wageType.Periods.length > 1;
    };

    this.removePeriod = function removePeriod() {
        if (!this.canRemovePeriod()) return;
        let index = this.wageType.Periods.indexOf(this.period);
        if (index >= 0) {
            this.wageType.Periods.splice(index, 1);
            this.period = this.wageType.Periods[0];
            this.periodChanged();
            if (this.editForm) {
                this.editForm.$setDirty();
            }
        }
    };

    this.loadItem(wageType).then((wageType) => {
        this.wageType = wageType;

        if (wageType.Id) {
            this.activeWageModels = wageModelInfos.filter(x => x.group === wageType.WageModelGroup);
        } else {
            this.activeWageModels = wageModelInfos;
            wageType.Periods = [createPeriod(EmptyPeriod)];
            wageType.RequireUnitPrice = true;
            wageType.RequireNumber = true;
            wageType.RequireAmount = true;
        }

        this.period = wageType.Periods[0];
        this.periodChanged();
    });

    this.editingVariable = null;

    this.createVariable = function createVariable() {
        return ({
            max: null,
            amount: null
        });
    };

    this.variableAdd = function variableAdd() {
        if (!this.variableApply()) return;

        this.editingVariable = this.createVariable();
        this.period.VariablePrice.items.push(this.editingVariable);
        this.variablefocus = true;
    };

    this.variableEdit = function variableEdit(item) {
        if (!this.variableApply()) return;

        this.variablefocus = true;
        this.editingVariable = item;
    };

    this.variableCanApply = function variableCanApply() {
        if (!this.variableform.$valid) return false;
        return true;
    };

    this.variableApply = function variableApply() {
        if (!this.editingVariable)
            return true;
        if (!this.variableCanApply())
            return false;
        this.editingVariable = null;
        this.period.VariablePrice.items.sort((a, b) => a.max - b.max);
        return true;
    };

    this.variableRemove = function variableRemove() {
        if (!this.editingVariable) return;

        var index = this.period.VariablePrice.items.indexOf(this.editingVariable);
        if (index >= 0) {
            this.period.VariablePrice.items.splice(index, 1);
            this.editingVariable = null;
            this.variableform.$setDirty();
        }
    };

    // TODO refactor so things like this are avoided
    const superSave = this.save.bind(this);
    this.save = function save() {
        if (!this.variableApply()) return;
        superSave();
    };
}]);